import { Helmet } from 'react-helmet-async';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const ModuleHelpPage = () => {
    return (
        <>
            <Helmet>
                <meta
                    content='noindex, nofollow'
                    name='robots'/>

                <title>Module Help</title>
            </Helmet>

            <main
                className='flex'
                id='main-content'
                style={{ minHeight: '100dvh' }}>
                <h1 className='sr-only'>
                    Module Help
                </h1>

                <div className='m-auto'>
                    <div className='layout-container pt-30 sm:pt-0 md:pt-20'>
                        <h2 className='type-style-2'>
                            Available Rich Content Short Codes
                        </h2>

                        <ul className='list-disc flex flex-col gap-20 mt-20 pl-20'>
                            <li><code>{'{{type:highlight,content:Get_in_touch}}'}</code></li>
                            <li><code>{'{{type:icon,icon:ThumbsUp}}'}</code></li>
                            <li><code>{'{{type:link,url:https://google.com,content:Get_started,icon:ArrowRightLarge}}'}</code></li>
                            <li><code>{'{{type:scroll,content:skiers|hikers|cyclists}}'}</code></li>
                        </ul>

                        <h2 className='type-style-2 mt-40'>
                            Available Icons
                        </h2>

                        <ul className='list-disc flex flex-col gap-20 mt-20 pl-20'>
                            <li><code>ArrowRightLarge</code></li>
                            <li><code>Bike</code></li>
                            <li><code>Boot</code></li>
                            <li><code>Flag</code></li>
                            <li><code>Heart</code></li>
                            <li><code>Shoe</code></li>
                            <li><code>ThumbsUp</code></li>
                            <li><code>Trophy</code></li>
                            <li><code>Water</code></li>
                        </ul>

                        <h2 className='type-style-2 mt-40'>
                            Notes
                        </h2>

                        <ul className='list-disc flex flex-col gap-20 mt-20 pl-20'>
                            <li>
                                Rich content types should contain no spaces, space between words should instead use an underscore e.g. Get_started
                            </li>
                        </ul>
                    </div>
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ModuleHelpPage;
